export default __webpack_public_path__ + "static/media/sandtexture.22e9be85.webp";